/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = theme => ({
  applicationNumberIconn: {
    marginLeft: '4px',
    // display: 'none',
    cursor: 'pointer',
    '& >img:active': {
      opacity: '0.5',
    },
  },
  successScreenContainer: {
    maxWidth: '750px !important',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0px',
  },
  applicationNumberLabel: {
    textTransform: 'none',
  },

  downloadPaymentReceiptContainer: {
    marginTop: '10px',
  },

  // successScreenHeader
  successScreenHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    backgroundColor: '#F8F8F8',
    padding: '24px',
    borderRadius: '0px',
    flexDirection: 'column',
  },
  successBoxContent: {
    backgroundColor: theme.palette.primary.grey,
    margin: '15px 0',
    borderRadius: '0px',
  },
  successScreenHeaderImg: {
    marginTop: '10px',
  },
  successScreenHeaderContent: {
    flex: 1,
    textAlign: 'center',
    paddingTop: '10px',
    '& $successScreenHeaderImg': {
      display: 'none',
    },
  },
  successScreenHeaderTitle: {
    fontWeight: '600',
    fontSize: '23px',
    lineHeight: '30px',
    textAlign: 'center',
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  headerTitleSuccess: {
    color: theme.palette.primary.successNew,
  },
  headerTitleRefused: {
    color: theme.palette.primary.darkErrorRed,
  },
  headerTitleTerminate: {
    color: '#A40000',
  },
  headerTitleReject: {
    color: theme.palette.primary.warningMango,
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
  },
  successScreenHeaderSubTitle: {
    color: theme.palette.secondary.dim,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    marginTop: '10px',
    textAlign: 'center',
  },

  mt20: {
    marginTop: '20px',
  },
  successScreenHeaderDownloadButton: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    display: 'inline-flex',
    width: '300px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    border: `1px solid ${theme.palette.primary.adgmBlack}`,
    borderRadius: '0px',
    padding: '10px 28px',
    backgroundColor: theme.palette.primary.white,
    '& img': {
      marginRight: '6px',
    },
    '& span': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },

  // applicationNumberContainer
  applicationNumberContainer: {
    order: '2',
  },

  applicationNumber: {
    width: '100%',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    color: theme.palette.primary.darkGrey,
    textAlign: 'right',
  },
  applicationNumberIcon: {
    marginLeft: '4px',
    display: 'none',
  },
  applicationNumberBold: {
    fontWeight: '600',
  },

  // successScreenMainContent
  successScreenMainContent: {
    order: '3',
  },

  detailItem: {
    borderBottom: `1.46951px solid ${theme.palette.primary.borderColor}`,
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
  },

  detailItemHorizontal: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
  },

  propertyTypeBadge: {
    color: theme.palette.primary.white,
    background: theme.palette.primary.adgmGreen,
  },

  totalAmount: {
    color: theme.palette.primary.main,
  },

  // successScreenFooter
  successScreenFooter: {
    order: '4',
    paddingTop: '32px',
  },

  successScreenFooterButton: {
    display: 'block',
    height: '60px',
    background: theme.palette.primary.main,
    color: theme.palette.primary.white,
    borderRadius: '0px',
    fontWeight: '600',
    fontSize: '16px',
    width: '100%',
    textTransform: 'none',
    '&:hover': {
      background: '#0088FF',
    },
  },

  [theme.breakpoints.down('sm')]: {
    successScreenContainer: {
      maxWidth: '100% !important',
      padding: '0px',
      minHeight: '90vh',
      paddingBottom: '80px',
      position: 'relative',
    },
    successScreenHeader: {
      order: '2',
      margin: '16px 16px 0px',
    },
    successScreenHeaderContent: {
      padding: '16px 0',
      textAlign: 'center',
      '& $successScreenHeaderImg': {
        display: 'block',
        margin: '16px auto 0 auto',
      },
    },

    successScreenHeaderDownloadButton: {
      display: 'flex',
    },
    successScreenMainContent: {
      padding: '0px 16px',
      marginBottom: '70px',
    },

    applicationNumberContainer: {
      order: '1',
      background: theme.palette.primary.grey,
      border: '0',
      padding: '16px',
    },

    applicationNumber: {
      textAlign: 'left',
    },
    applicationNumberIcon: {
      display: 'inline-block',
    },
    successScreenFooter: {
      padding: '0px 16px',
      position: 'absolute',
      bottom: '70px',
      width: '100%',
      left: '0px',
    },
  },
});

export default styles;
